// Generated by scripts/build-ui-icons.mjs.
export { Lightning as default } from "../ui/glyphs-5";
